import debug from "debug";
import plugin from "../../lib/plugin";
import debounce from "../../lib/debounce";

const log = debug("iframe-resize");

const ELEMENT_SELECTOR = "[data-iframe-resize]";

class IframeResize {
    constructor(element, options) {
        this.element = element;
        this.options = options;
        log(element, options);
        this.watch();
    }

    get iframe() {
        return this.element.querySelector("iframe");
    }

    watch() {
        window.addEventListener(
            "message",
            debounce(this.messageHandler.bind(this), 100)
        );
    }

    messageHandler(event) {
        log("message", event);
        if (event.origin !== window.location.origin) {
            return false;
        }
        if (event.data === "resize" && this.iframe && this.iframe.contentWindow === event.source) {
            this.resize(this.iframe.contentWindow.document.body.scrollHeight);
        }
    }

    resize(height) {
        log("resize", height);
        this.iframe.style.height = height + "px";
    }
}

IframeResize.DEFAULTS = {};

plugin("iframeResize", IframeResize);

export function exec() {
    $(ELEMENT_SELECTOR).iframeResize();
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/iframe-resize/iframe-resize.js